<template>
  <div
    class="fixed bottom-0 z-10 flex min-h-16 w-full items-center rounded-t-lg bg-fp-gray-2/40 p-2 backdrop-blur-sm md:min-h-31 md:p-8"
    :class="offsetForSidebar ? 'md:left-64 md:w-[calc(100vw-16rem)]' : ''"
  >
    <div class="w-full" :class="contentMaxWidthClass">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    contentMaxWidthClass?: string
    offsetForSidebar?: boolean
  }>(),
  {
    contentMaxWidthClass: 'max-w-4xl',
    offsetForSidebar: true,
  }
)
</script>
